// removed by extract-text-webpack-plugin
module.exports = {"previousLink":"PreviousLink-module__previousLink___2YXbU","iconLeft":"PreviousLink-module__iconLeft___zbGZi"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/PreviousLink/PreviousLink.module.css
// module id = 650
// module chunks = 0